export const getBreadcrumbs = (title) => [
  { text: 'Invoices', to: '../invoices' },
  { text: title },
];
